import React from 'react';
import { FieldArray } from 'formik';
import { IntermediaryTextField } from '../../../IntermediaryForms/components';
import { FormattedMessage } from 'react-intl';
import { Button, IconPlus, IconRemove } from 'suomifi-ui-components';

export const CustomFieldArray = ({
  name,
  formik,
  i18n,
  loc,
  overrideErrorStatus,
  customRef
}) => {
  const obj = formik.values?.[name];
  return (
    <FieldArray
      name={`${name}`}
      render={helpers => (
        <>
          <IntermediaryTextField
            label={`${loc}.${name}_label`}
            hintText={i18n(`${loc}.${name}_hint_text`)}
            customRef={() => customRef(name)} // NOTE: we bypass the multiple ref issue by using the 1st entry of the array as the ref
            overrideStatus={overrideErrorStatus(formik, name) ? 'error' : false}
            overrideStatusText={
              overrideErrorStatus(formik, name) ? formik.errors?.[name] : false
            }
            name={`${name}.0`}
            width={'51%'}
          />
          {obj &&
            obj.length > 1 &&
            obj.map((contact, index) => {
              if (index === 0) {
                return;
              }
              return (
                <>
                  <div>
                    <div style={{ display: 'inline-block', width: '597px' }}>
                      <IntermediaryTextField
                        labelMode={'hidden'}
                        name={`${name}.${index}`}
                        width={'100%'}
                      />
                    </div>
                    <div
                      style={{
                        display: 'inline-block',
                        verticalAlign: 'top',
                        paddingTop: '16px'
                      }}
                    >
                      <Button
                        icon={<IconRemove />}
                        variant={'secondary'}
                        style={{
                          lineHeight: '16px',
                          verticalAlign: '16px',
                          marginLeft: '15px',
                          display: !index ? 'none' : 'inline-block'
                        }}
                        type="button"
                        onClick={() => helpers.remove(index)}
                      >
                        <FormattedMessage id={'general.form.delete'} />
                      </Button>
                    </div>
                  </div>
                </>
              );
            })}
          <Button
            icon={<IconPlus />}
            variant={'secondary'}
            type="button"
            onClick={() => helpers.push('')}
          >
            <FormattedMessage id={`${loc}.add_new_address`} />
          </Button>
          <br />
        </>
      )}
    />
  );
};
